import React, { useRef, useState } from 'react'
import { withPrefix } from 'gatsby'
import Slider from 'react-slick'
import s from './agencyCarousel.module.css'
import { ArrowRight } from '../../../svg/arrow_right'
import { GTMEvents } from '../../../lib/GTMevents'

const AgencyCarousel = () => {
  /* SLIDER AGENCIA */
  const sliderAgenciaRef = useRef()

  const [sliderCurrentAgencia, setSliderCurrentAgencia] = useState({
    activeSlide: 1,
    activeSlideText: 'Cámbiate a Prima AFP',
  })

  const heroAgenciaData = [
    {
      title: 'Cámbiate a Prima AFP',
      image: '/images/man-smartphone-sitting.svg',
      imageMobile: '/images/man-in-tablet2.svg',
      link: 'https://www.prima.com.pe/traspasos/pasos0',
      bgClass: 'bg-orange-8',
    },
    {
      title: 'Jubilación a tu medida',
      image: '/images/woman-pig.svg',
      imageMobile: '/images/woman-piggy-bank.svg',
      link: withPrefix('/jubilacion-y-pension/jubilacion/'),
      bgClass: 'bg-gray--6',
    },
    {
      title: 'Nuestra estrategia sostenible',
      image: '/images/man-run.svg',
      imageMobile: '/images/man-run2.svg',
      link: withPrefix('/sobre-prima-afp/responsabilidad-social/'),
      bgClass: 'bg-turquoise-1',
    },
    {
      title: '25% para tu primera vivienda',
      image: '/images/man-keys.svg',
      imageMobile: '/images/hand-keys.svg',
      link: withPrefix(
        '/aportes-y-fondo/uso-del-25-de-mi-fondo-para-un-inmueble/'
      ),
      bgClass: 'bg-gray--15',
    },
    {
      title: 'Alcanza tus metas de ahorro e inversión',
      image: '/images/woman-yellow.svg',
      imageMobile: '/images/woman-check2.svg',
      link: withPrefix('/aportes-y-fondo/tipos-de-aportes/'),
      bgClass: 'bg-yellow-1',
    },
  ]

  const slickSettingsAgencia = {
    className: `${s.sliderVerticalAgencia}`,
    arrows: true,
    verticalSwiping: true,
    centerPadding: '100px',
    vertical: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    slide: 'div',
    autoplaySpeed: 3000,
    initialSlide: 1,
    centerMode: true,
    infinite: true,
    appendDots: dots => <ul style={{ bottom: '-35px' }}>{dots}</ul>,
    customPaging: i => <span className="ft-slick__dots--custom"></span>,
    beforeChange: (currentIndex, _) => {
      setSliderCurrentAgencia({
        activeSlide: currentIndex + 1,
        activeSlideText: sliderAgenciaRef.current.innerSlider.list
          .querySelector(`[data-id="${currentIndex}"]`)
          .getAttribute('data-text'),
      })
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '0px',
          verticalSwiping: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          vertical: false,
          infinite: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          centerPadding: '0px',
          verticalSwiping: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          vertical: false,
          centerMode: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '0px',
          verticalSwiping: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          vertical: false,
          centerMode: true,
        },
      },
    ],
  }
  /* FIN SLIDER AGENCIA */

  return (
    <div className="containerWrap">
      <div className="bg-white flex direction-column direction-row@lg">
        <div className={`w-100 w-55@lg order-2 order-1@lg tw-mb-14 tw-mb-0@lg`}>
          <div className={`${s.itemRowCarouselWrap}`}>
            <Slider ref={sliderAgenciaRef} {...slickSettingsAgencia}>
              {heroAgenciaData.map((item, index) => (
                <div
                  className={`tw-py-3`}
                  data-id={index}
                  data-text={item.title}
                  key={item.title}
                >
                  <div
                    className={`${s.itemRowCarousel} brad-4@lg overflow-hidden ${item.bgClass} flex direction-column direction-row@lg justify-between justify-around@lg tw-pl-8@lg`}
                  >
                    <div
                      className={`tw-px-8 tw-pt-10 tw-p-0@lg flex direction-column order-1 justify-center items-start w-100 w-55@lg`}
                    >
                      <div
                        className={`font-family-secondary fw-7 tw-f-24 tw-f-24@lg tw-mt-0 tw-mb-4 left`}
                      >
                        {item.title}
                      </div>

                      <div
                        onClick={() =>
                          GTMEvents.BtnHomeSliderColumnVerMas(
                            'Todo lo que puedes hacer en agencia',
                            sliderCurrentAgencia.activeSlideText,
                            'Ver más'
                          )
                        }
                        className={`font-family-secondary fw-6 tw-f-16 tw-f-16@lg c-orange-2`}
                      >
                        <a
                          id="GTM-MOD-MEP-BTN-SLIDER-CARD"
                          href={item.link}
                          target="_blank"
                          className={`c-orange-2 underline`}
                          aria-label={item.title}
                        >
                          Quiero saber más{' '}
                          <ArrowRight
                            className={'tw-pt-1'}
                            width={16}
                            height={16}
                            fill={'#CA3F04'}
                          />
                        </a>
                      </div>
                    </div>

                    <div
                      className={`flex justify-center items-end justify-end@lg items-end@lg order-2 w-100 w-45@lg`}
                    >
                      <img
                        src={withPrefix(item.image)}
                        alt={item.title}
                        className={`${s.itemRowCarousel_image}`}
                      />

                      <img
                        src={withPrefix(item.imageMobile)}
                        alt={item.title}
                        className={`${s.itemRowCarouselMobile_image} tw-mx-4 m-auto`}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>

        <div
          className={`w-100 w-45@lg order-1 order-2@lg tw-pt-12 tw-pt-0@lg tw-pb-6 tw-pb-12@lg tw-p-10@lg tw-pr-0@lg tw-pl-18@lg flex@lg justify-center direction-column@lg`}
        >
          <h2 className="font-family-secondary tw-f-24 tw-f-32@lg center left@lg tw-mt-0 tw-mb-4 tw-pr-16@lg tw-pl-10@lg">
            Todo lo que puedes hacer en agencia
          </h2>

          <div
            className={`font-family-primary tw-f-16 center left@lg tw-px-10 tw-pr-0@lg tw-pl-10@lg tw-mb-0 tw-mb-9@lg `}
          >
            Ingresa a cada sección para informarte o realizar el trámite que
            desees hacer.
          </div>

          <div className={`tw-pl-10@lg dn flex@lg`}>
            <div className={`tw-mr-4 flex direction-column`}>
              <button
                className={`${s.btnIcoArrowTop} tw-mb-6`}
                onClick={() => sliderAgenciaRef.current.slickPrev()}
              >
                <img
                  src={withPrefix('/images/ico-arrow-circle.svg')}
                  alt=""
                  className={`${s.btnIcoArrowTop} db`}
                />
              </button>

              <button
                className={`${s.btnIcoArrowTop}`}
                onClick={() => sliderAgenciaRef.current.slickNext()}
              >
                <img
                  src={withPrefix('/images/ico-arrow-circle.svg')}
                  alt=""
                  className={`${s.btnIcoArrowTop} ${s.down} db`}
                />
              </button>
            </div>

            <div>
              <p className="font-family-primary tw-f-16 tw-mb-4">
                {sliderCurrentAgencia.activeSlide} de 5
              </p>
              <h3 className="font-family-secondary tw-f-20 fw-7">
                {sliderCurrentAgencia.activeSlideText}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgencyCarousel
